import {
  CREATE_AREA,
  FETCH_AREAS,
  DELETE_AREA_AND_REFETCH,
  TAKE_AREA,
  DELETE_AREA,
} from 'actions/types'

interface AreasState {
  areas: object[]
}

const AreasInitialState = {
  areas: [],
}

export const areasReducer = (state: AreasState = AreasInitialState, action: any) => {
  const { type, payload } = action

  switch (type) {
    case CREATE_AREA:
      return {
        ...state,
      }
    case FETCH_AREAS:
      return {
        ...state,
        areas: payload,
      }
    case DELETE_AREA_AND_REFETCH:
      return {
        ...state,
        areas: payload,
      }
    default:
      return state
  }
}

interface AreaState {
  area: null | string
  isOpen: boolean
}

const AreaInitialState = {
  area: null,
  isOpen: false,
}

export const areaReducer = (state: AreaState = AreaInitialState, action: any) => {
  const { type, payload } = action

  switch (type) {
    case TAKE_AREA:
      return {
        ...state,
        area: payload,
        isOpen: true,
      }
    case DELETE_AREA:
      return {
        ...state,
        area: payload,
        isOpen: false,
      }
    default:
      return state
  }
}
